export const MENU_LIST = [
  {
    label: 'About',
    link: 'mverse',
  },
  {
    label: 'Overview',
    link: 'overview',
  },
  {
    label: 'Ecosystem',
    link: 'ecosystem',
  },
  {
    label: 'Service',
    link: 'service',
  },
  {
    label: 'Download',
    link: 'download',
  },
  {
    label: 'Team',
    link: 'team',
  },
  {
    label: 'Contact us',
    link: 'contact',
  },
]
